import { CIMSColumn } from 'components/CIMSTable/CIMSColumn/types'
import { IdentifiedFieldIssue } from '../../../IFITrackerContext/types'
import { IFIReportType, alphabeticalCompare, alphabeticalSort } from 'shared'
import { useImportRulesHelpText } from '../../useImportRulesHelpText'

export function useReportType(): CIMSColumn<IdentifiedFieldIssue> {
  return {
    title: 'Report Type',
    render: ({ reportTypeId }) => IFIReportType.fromIdOrFail(reportTypeId).type,
    width: 170,
    help: useImportRulesHelpText(),
    sort: {
      with: 'callback',
      onCompare: (a, b) => {
        const A = IFIReportType.fromIdOrFail(a.reportTypeId)
        const B = IFIReportType.fromIdOrFail(b.reportTypeId)
        return alphabeticalCompare(A, B, 'type')
      },
    },
    filter: {
      type: 'default',
      with: 'items',
      items: IFIReportType.sort(alphabeticalSort('type')).map(
        ({ id, type }) => ({
          text: type,
          value: id,
        })
      ),
      key: 'reportTypeId',
    },
  }
}
